import {documentToHtmlString} from '@contentful/rich-text-html-renderer'
import type {PrimerComponentFaqGroup} from '../../schemas/contentful/contentTypes/primerComponentFaqGroup'

type FAQSeoSchemaProps = {
  faqGroup: PrimerComponentFaqGroup
  dataTestId?: string
}

export const FAQSeoSchema = ({faqGroup, dataTestId}: FAQSeoSchemaProps) => {
  const mainEntity =
    faqGroup.fields.faqs?.flatMap(faq => {
      return faq.fields.blocks?.flatMap(block => {
        return block.fields.questions?.map(question => {
          return {
            '@type': 'Question',
            name: question.fields.question,
            acceptedAnswer: {
              '@type': 'Answer',
              text: documentToHtmlString(question.fields.answer),
            },
          }
        })
      })
    }) ?? []

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity,
  }
  // Escape `<` to prevent a URI like `</script>` from breaking out of the JSON-LD script tag
  const jsonLd = JSON.stringify(structuredData).replace(/</g, '\\u003c')

  /* eslint-disable-next-line react/no-danger */
  return <script data-testid={dataTestId} type="application/ld+json" dangerouslySetInnerHTML={{__html: jsonLd}} />
}
